import { z } from "zod";
import { activityActorTypes, activitySources } from "./activity-event.schema";

/**
 * Actor identity for an activity-event emission. Resolved at request time from
 * TenantContext.userId + apiKeyId + an optional source override. ADV-918.
 */
export const ActorContextSchema = z.object({
  actor_type: z.enum(activityActorTypes).describe("Actor Type"),
  actor_id: z.string().nullable().describe("Actor"),
  source: z.enum(activitySources).describe("Source"),
});

export type ActorContext = z.infer<typeof ActorContextSchema>;
